var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{directives:[{name:"auth-image",rawName:"v-auth-image",value:(_vm.avatarUrl),expression:"avatarUrl"}],staticStyle:{"width":"48px","height":"48px"},attrs:{"rounded":"circle","src":""},on:{"error":_vm.handleError}})}
var staticRenderFns = []

export { render, staticRenderFns }